// Poslední 4 navštívené stanice přes zjednodušenou stránku /station-charts (varianta B) —
// samostatné od cw_last_stations (StationDetailLayout, viz useLastStations.js), protože
// odkazy vedou na jinou routu (/station-charts/:ghId, ne /station/:ghId).
const KEY = 'cw_last_station_charts_stations'
const MAX = 4

export function getLastStationChartsStations() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

export function addLastStationChartsStation(station) {
  const list = getLastStationChartsStations().filter(s => s.gh_id !== station.gh_id)
  list.unshift({ gh_id: station.gh_id, name: station.full_name || station.name })
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)))
}
